<template>
  <div v-if="leadScriptApi">
    <h1>Lead script api</h1>
    <v-btn :to="{name:'leadScriptApis'}">
      <v-icon>chevron_left</v-icon>Lead script apis
    </v-btn>
    <h3>Promotions</h3>
    <div v-if="promotions">
      <v-btn
        v-for="promotion in promotions"
        :key="promotion.id"
        :to="{name:'promotion', params:{id:promotion.id}}"
      >{{`${promotion.code} ${promotion.body}`}}</v-btn>
    </div>
    <v-text-field label="Name" v-model="leadScriptApi.name" outline />
    <v-select
      v-model="leadScriptApi.leadtypeid"
      :items="leadTypes"
      label="Lead type"
      item-value="id"
      item-text="label"
      outline
    />
    <v-text-field label="Endpoint" v-model="leadScriptApi.endpoint" outline />
    <v-text-field label="Username" v-model="leadScriptApi.username" outline />
    <v-text-field label="Password" v-model="leadScriptApi.password" outline />
    <v-text-field label="Version" v-model="leadScriptApi.version" outline :readonly="true" />
    <v-select
      v-model="leadScriptApi.leadscriptid"
      :items="leadScripts"
      label="LeadScript"
      item-value="id"
      outline
    >
      <template
        slot="selection"
        slot-scope="data"
      >{{ `${data.item.id} - ${data.item.apiName} - ${data.item.apiVersion}` }}</template>
      <template
        slot="item"
        slot-scope="data"
      >{{ `${data.item.id} - ${data.item.apiName} - ${data.item.apiVersion}` }}</template>
      <template slot="append" v-if="leadScript">
        <v-btn
          :to="{name:'leadScript', params:{id:leadScript.id}}"
          small
        >{{`${leadScript.id} - ${leadScript.apiName} - ${leadScript.apiVersion}`}}</v-btn>
      </template>
      <template slot="append-outer" v-if="leadScriptApi.leadscriptid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a @click="leadScriptApi.leadscriptid = null" v-on="on">
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Remove the lead script</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-btn @click="saveLeadScriptApi">
      <v-icon>save</v-icon>Save
    </v-btn>
    <div v-if="$route.params.id">
      <hr />
      <h3>Manual lead processing</h3>
      <v-select
        v-model="promotionid"
        :items="promotions"
        label="Promotion"
        item-value="id"
        item-text="code"
        outline
      />
      <v-textarea outline label="Raw text" v-model="leadRaw" />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-checkbox v-model="send" label="Send email" v-on="on" />
        </template>
        <span>Send email to client at the same time</span>
      </v-tooltip>
      <v-btn @click="processLead">
        <v-icon>save</v-icon>Send
      </v-btn>
      <v-btn @click="processLeads">
        <v-icon>settings</v-icon>Process batch
      </v-btn>
    </div>
    <v-snackbar v-model="snackbar" :multi-line="false" :timeout="4000" :top="true">
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "LeadscriptApi",
  metaInfo() {
    return {
      title: "Lead script api",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  computed: {
    leadScript() {
      const leadScriptsMap = this.leadScripts
        ? convertListOfObjectsToMap(this.leadScripts, "id")
        : undefined;
      return this.leadScriptApi && leadScriptsMap
        ? leadScriptsMap[this.leadScriptApi.leadscriptid]
        : undefined;
    },
  },
  data() {
    return {
      leadScriptApi: null,
      promotions: null,
      promotionid: null,
      leadScripts: null,
      leadRaw: null,
      leadTypes: [
        { id: 0, label: "None" },
        { id: 1, label: "QuoteXpress" },
        { id: 2, label: "Really Moving" },
        { id: 3, label: "The Conveyancing Network" },
        { id: 4, label: "Hoowla" },
        { id: 5, label: "Pinlocal" },
      ],
      send: true,
      snackbar: false,
      snackbarText: null,
    };
  },
  methods: {
    async fetchLeadScriptApi() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/leadScriptApis/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.leadScriptApi = response.data;
    },
    async fetchPromotions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/leadScriptApis/${this.$route.params.id}/promotions`
      );
      // console.log(response.data);
      this.promotions = response.data;
      if (this.promotions && this.promotions.length) {
        this.promotionid = this.promotions[0].id;
      }
    },
    async fetchLeadScripts() {
      const response = await nbmlaw.get(`/cors/admin/sales/leadScripts`);
      // console.log(response.data);
      this.leadScripts = response.data;
    },
    saveLeadScriptApi() {
      if (this.$route.params.id) {
        this.updateLeadScriptApi();
      } else {
        this.createLeadScriptApi();
      }
    },
    async updateLeadScriptApi() {
      await nbmlaw.put(
        `/cors/admin/sales/leadScriptApis/${this.$route.params.id}`,
        this.leadScriptApi
      );
      // console.log(response.data);
      this.$router.push({ name: "leadScriptApis" });
    },
    async createLeadScriptApi() {
      await nbmlaw.post(`/cors/admin/sales/leadScriptApis`, this.leadScriptApi);
      // console.log(response.data);
      this.$router.push({ name: "leadScriptApis" });
    },
    async processLead() {
      try {
        await nbmlaw.put(
          `/cors/admin/sales/leadScriptApis/${this.$route.params.id}/promotions/${this.promotionid}/raw`,
          this.leadRaw
        );
        this.snackbar = true;
        this.snackbarText = "Lead processed";
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err;
      }
    },
    async processLeads() {
      try {
        await nbmlaw.put(
          `/cors/admin/sales/leadScriptApis/${this.$route.params.id}/promotions/${this.promotionid}`,
          null
        );
        this.snackbar = true;
        this.snackbarText = "Leads processed";
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err;
      }
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchLeadScriptApi();
          this.fetchPromotions();
        } else {
          this.leadScriptApi = {};
        }
        this.fetchLeadScripts();
      },
    },
  },
};
</script>